class MultiquoteErrorPermissions {
    constructor({ show = false } = {}) {
        this.show = show
    }
}

export default MultiquoteErrorPermissions
